module.exports = {
      id: "breaking-news-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#breaking-news",
      toString: function () {
        return this.url;
      }
    }